import React from "react";
import Container from "react-bootstrap/Container";
import Nav from "react-bootstrap/Nav";
import Navbar from "react-bootstrap/Navbar";
import "./Navbar.css";
import linkedin from "../../../assets/icons/linkedin.svg";
import insta from "../../../assets/icons/insta.svg";
import github from "../../../assets/icons/github.svg";
import { Stack } from "@mui/material";
import { HiMenuAlt3 } from "react-icons/hi";
import { Link } from "react-scroll";

export default function NavbarHead() {
  return (
    <Navbar
      collapseOnSelect
      expand="lg"
      variant="dark"
      className="nav_bar"
      style={{ position: "fixed", width: "100%", top: "0", zIndex: "999" }}
    >
      <Container>
        <Stack flexDirection="row" gap="50px" alignItems="center">
          <Stack>
            <Navbar.Brand
              style={{
                fontFamily: "'Cyberpunk Is Not Dead'",
                fontStyle: "sans-serif",
              }}
            >
              <Link
                to="header"
                spy={true}
                smooth={true}
                // offset={-70}
                duration={250}
                style={{
                  textDecoration: "none",
                  color: "white",
                  cursor: "pointer",
                }}
              >
                THARIN
              </Link>
            </Navbar.Brand>
          </Stack>

          <Stack flexDirection="row" gap="20px">
            {/* <Nav.Link className="justify-content-center  link_icon"> */}
            <a href="https://www.linkedin.com/in/th4rin/">
              <img
                src={linkedin}
                alt=""
                style={{ width: "25px", height: "25px" }}
              />
            </a>
            {/* </Nav.Link> */}
            {/* <Nav.Link className="justify-content-center  link_icon"> */}
            <a href="https://www.instagram.com/tharin_uiux/">
              <img
                src={insta}
                alt=""
                style={{ width: "25px", height: "25px" }}
              />
            </a>
            {/* </Nav.Link> */}
            {/* <Nav.Link className="justify-content-center   link_icon"> */}
            <a href="https://github.com/">
              <img
                src={github}
                alt=""
                style={{ width: "25px", height: "25px" }}
              />
            </a>
            {/* </Nav.Link> */}
          </Stack>
        </Stack>
        <Navbar.Toggle
          aria-controls="responsive-navbar-nav"
          className="toggle no-border"
          style={{
            border: "none",
            color: "#00adb5",
            cursor: "pointer",
          }}
        >
          <HiMenuAlt3 />
        </Navbar.Toggle>
        <Navbar.Collapse
          id="responsive-navbar-nav"
          className="justify-content-end "
          style={{ textAlign: "center" }}
        >
          <Nav className="d-none d-lg-inline-block"></Nav>
          <Nav className="">
            <Nav.Link
              style={{
                color: "white",
                fontFamily: "g Game TC",
                fontStyle: "sans-serif",
                fontSize: "14px",
                fontWeight: "400",
              }}
              className="link"
            >
              <Link
                to="about"
                spy={true}
                smooth={true}
                offset={-70}
                duration={250}
                style={{ textDecoration: "none", color: "white" }}
              >
                About
              </Link>
            </Nav.Link>
            <Nav.Link
              style={{
                color: "white",
                fontFamily: "g Game TC",
                fontStyle: "sans-serif",
                fontSize: "14px",
                fontWeight: "400",
              }}
              className="link"
            >
              <Link
                to="my_journey"
                spy={true}
                smooth={true}
                offset={-70}
                duration={250}
                style={{ textDecoration: "none", color: "white" }}
              >
                My Journey
              </Link>
            </Nav.Link>
            <Nav.Link
              style={{
                color: "white",
                fontFamily: "g Game TC",
                fontStyle: "sans-serif",
                fontSize: "14px",
                fontWeight: "400",
              }}
              className="link"
            >
              <Link
                to="skills"
                spy={true}
                smooth={true}
                offset={-70}
                duration={250}
                style={{ textDecoration: "none", color: "white" }}
              >
                Skills
              </Link>
            </Nav.Link>
            <Nav.Link
              style={{
                color: "white",
                fontFamily: "g Game TC",
                fontStyle: "sans-serif",
                fontSize: "14px",
                fontWeight: "400",
              }}
              className="link"
            >
              <Link
                to="projects"
                spy={true}
                smooth={true}
                offset={-70}
                duration={250}
                style={{ textDecoration: "none", color: "white" }}
              >
                Projects
              </Link>
            </Nav.Link>
            <Nav.Link
              style={{
                color: "white",
                fontFamily: "g Game TC",
                fontStyle: "sans-serif",
                fontSize: "14px",
                fontWeight: "400",
              }}
              className="link"
            >
              <Link
                to="contacts"
                spy={true}
                smooth={true}
                offset={-70}
                duration={250}
                style={{ textDecoration: "none", color: "white" }}
              >
                Contacts
              </Link>
            </Nav.Link>
          </Nav>
        </Navbar.Collapse>
      </Container>
    </Navbar>
  );
}
